import { Component, OnInit, ViewChild } from "@angular/core";
import { NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AutoTableUtils } from "src/app/shared/utils/autoTable-utils";
import { ReportePresupuestoService } from "src/app/services/reporte-presupuesto.service";
import { LotePresupuesto } from "src/app/models/entities/lote-presupuesto";
import { take, filter } from "rxjs/operators";
import { CatalogoService } from "src/app/services/catalogo.service";
import { UnidadResponsable } from "src/app/models/entities/unidad-responsable";
import { RutaCatalogoEnum } from "src/app/shared/enums/ruta-catalogo.enum";
import { PresupuestoEstado } from "src/app/models/entities/presupuesto-estado";
import { PdfUtils } from "src/app/shared/utils/pdf-utils";
import { LoaderService } from "src/app/services/loader.service";

@Component({
  selector: "modal-seguimiento-pef",
  templateUrl: "./modal-seguimiento-pef.component.html",
  styleUrls: ["./modal-seguimiento-pef.component.scss"],
})
export class ModalSeguimientoPefComponent implements OnInit {
  public lotesPresupuestos: LotePresupuesto[] = [];
  public loteFederales: LotePresupuesto;
  public loteRurales: LotePresupuesto;

  public catUnidadesResponsables: UnidadResponsable[] = [];
  public caminosRuralesAlimentadores: PresupuestoEstado[] = [];
  public programasRurales: PresupuestoEstado[] = [];
  public sumasProgramasRurales: any[] = [];
  public sumasTotalProgramasRurales: any;
  public sumaTotalCaminosRurales: any;
  public sumaCaminosRuralesAlimentadores: any[] = [];
  public datosRurales: any;

  @ViewChild("modalSeguimientoPEF")
  public modalSeguimientoPEF: any;
  public modalActivo: NgbModalRef;

  public tipoProgramaSeleccionado: string = "";

  public datosSeguimientoPEF: any;
  public sumasProgramas: any[] = [];
  public sumasTotalProgramas: any;

  public reporteCompleto: any[] = [];

  public sumaObras: any[] = [];
  public sumaTotalObras: any;
  public fechaActual: any;
  public fechaFederal: any;
  public fechaRural: any;

  public readonly CARRETERAS_FEDERALES: string = "1";
  public readonly CAMINOS_RURALES: string = "0";
  public readonly ESTUDIOS_Y_PROYECTOS_RURALES: string =
    "Programa de Estudios y Proyectos de Caminos Rurales y Alimentadores 2020";
  public readonly CONSERVACION_INFRAESTRUCTURA: string =
    "Programa de Conservación de Infraestructura de Caminos Rurales y Carreteras 2020";
  public readonly DERECHO_DE_VIA: string = "LIBERACIÓN DE DERECHO DE VÍA";
  public readonly ESTUDIOS_Y_PROYECTOS_FEDERALES: string =
    "ESTUDIOS Y PROYECTOS DE CONSTRUCCIÓN DE CARRETERAS";
  public readonly TITULO_CONSTRUCCION_MODERNIZACION_FEDERALES: string =
    "Programa de Construcción y Modernizacion de Carreteras";
  public readonly TITULO_PROGRAMA_DERECHO_VIA_FEDERALES: string =
    "Programa de Derecho de Vía de Carreteras Federales";
  public readonly TITULO_PROGRAMA_ESTUDIOS_PROYECTOS_FEDERALES: string =
    "Programa de Estudios y Proyectos de Carreteras Federales";
  public readonly TITULO_CAMINOS_RURALES_Y_ALIMENTADORES: string =
    "Programa de Caminos Rurales y Alimentadores";
  public readonly TITULO_PROGRAMA_CONSERVACION_CARRETERAS: string =
    "Programa de Conservación de Carreteras (Caminos Rurales y Alimentadores)";
  public readonly TITULO_PROGRAMA_ESTUDIOS_PROYECTOS_RURALES: string =
    "Programa de Estudios y Proyectos de Caminos Rurales y Alimentadores";

  public presupuestosFederales: PresupuestoEstado[] = [];
  public presupuestosRurales: PresupuestoEstado[] = [];

  public obrasFederales: PresupuestoEstado[] = [];
  public derechoViaFederales: PresupuestoEstado[] = [];
  public estudiosProyectosFederales: PresupuestoEstado[] = [];

  public obrasRurales: PresupuestoEstado[] = [];
  public conservacionInfraestructuraRurales: PresupuestoEstado[] = [];
  public estudiosProyectosRurales: PresupuestoEstado[] = [];

  public sumasDerechoViaFederales: any[] = [];
  public sumasEstudiosProyectosFederales: any[] = [];
  public sumasTotalDerechoViaFederales: any;
  public sumasTotalEstudiosProyectosFederales: any;

  public sumasConvervacionReconstruccionRurales: any[] = [];
  public sumasEstudiosProyectosRurales: any[] = [];
  public sumasTotalConvervacionReconstruccionRurales: any;
  public sumasTotalEstudiosProyectosRurales: any;

  public infoPreparada: boolean = false;

  constructor(
    private modalService: NgbModal,
    private loaderScreenService: LoaderService,
    private autoTable: AutoTableUtils,
    private reportePresupuestoService: ReportePresupuestoService,
    private catalogoService: CatalogoService,
    private pdfUtils: PdfUtils
  ) {}

  ngOnInit() {}

  public async abrirlModalSeguimientoPEF(tipoPrograma: string): Promise<void> {
    this.reporteCompleto = [];
    this.fechaActual = null;
    this.tipoProgramaSeleccionado = tipoPrograma;
    await this.obtenerCatalogos();
    await this.obtenerDatos();
    await this.identificarTipoPrograma();
    this.modalActivo = this.modalService.open(this.modalSeguimientoPEF, {
      centered: true,
      size: "lg",
      windowClass: "modal-ficha-tecnica",
    });
    this.infoPreparada = true;
  }

  public async obtenerCatalogos(): Promise<any> {
    this.catUnidadesResponsables = await this.catalogoService
      .obtenerCatalogo<UnidadResponsable>(
        RutaCatalogoEnum.UNIDADES_RESPONSABLES
      )
      .pipe(take(1))
      .toPromise();
  }

  public async obtenerDatos() {
    this.loteFederales = null;
    this.obrasFederales = [];
    this.derechoViaFederales = [];
    this.estudiosProyectosFederales = [];

    this.loteRurales = null;
    this.obrasRurales = [];
    this.conservacionInfraestructuraRurales = [];
    this.estudiosProyectosRurales = [];

    this.datosSeguimientoPEF = null;

    this.sumaObras = [];
    this.sumaTotalObras = null;
    this.sumasProgramas = [];
    this.sumasTotalProgramas = null;

    this.lotesPresupuestos = await this.reportePresupuestoService
      .findByAnioPef("")
      .pipe(take(1))
      .toPromise();

    this.loteFederales = this.lotesPresupuestos.find(
      (presupuestos: LotePresupuesto) =>
        presupuestos.keyCatDireccionAdjunta === this.CARRETERAS_FEDERALES
    );
    for (
      let indexUR = 0;
      indexUR < this.catUnidadesResponsables.length;
      indexUR++
    ) {
      for (
        let indice = 0;
        indice <
        this.loteFederales.lotePresupuestoEstado.presupuestosEstados.length;
        indice++
      ) {
        if (
          this.catUnidadesResponsables[indexUR].cve.toString() ===
          this.loteFederales.lotePresupuestoEstado.presupuestosEstados[indice]
            .ur
        ) {
          if (
            this.loteFederales.lotePresupuestoEstado.presupuestosEstados[indice]
              .nombreObra !== this.ESTUDIOS_Y_PROYECTOS_FEDERALES &&
            this.loteFederales.lotePresupuestoEstado.presupuestosEstados[indice]
              .nombreObra !== this.DERECHO_DE_VIA
          ) {
            this.obrasFederales.push(
              this.loteFederales.lotePresupuestoEstado.presupuestosEstados[
                indice
              ]
            );
          } else if (
            this.loteFederales.lotePresupuestoEstado.presupuestosEstados[indice]
              .nombreObra === this.DERECHO_DE_VIA
          ) {
            this.derechoViaFederales.push(
              this.loteFederales.lotePresupuestoEstado.presupuestosEstados[
                indice
              ]
            );
          } else if (
            this.loteFederales.lotePresupuestoEstado.presupuestosEstados[indice]
              .nombreObra === this.ESTUDIOS_Y_PROYECTOS_FEDERALES
          ) {
            this.estudiosProyectosFederales.push(
              this.loteFederales.lotePresupuestoEstado.presupuestosEstados[
                indice
              ]
            );
          }
        }
      }
    }

    this.loteRurales = this.lotesPresupuestos.find(
      (presupuestos: LotePresupuesto) =>
        presupuestos.keyCatDireccionAdjunta === this.CAMINOS_RURALES
    );
    for (
      let indexUR = 0;
      indexUR < this.catUnidadesResponsables.length;
      indexUR++
    ) {
      for (
        let indice = 0;
        indice <
        this.loteRurales.lotePresupuestoEstado.presupuestosEstados.length;
        indice++
      ) {
        if (
          this.catUnidadesResponsables[indexUR].cve.toString() ===
          this.loteRurales.lotePresupuestoEstado.presupuestosEstados[indice].ur
        ) {
          if (
            this.loteRurales.lotePresupuestoEstado.presupuestosEstados[indice]
              .nombreObra !== this.ESTUDIOS_Y_PROYECTOS_RURALES &&
            this.loteRurales.lotePresupuestoEstado.presupuestosEstados[indice]
              .nombreObra !== this.CONSERVACION_INFRAESTRUCTURA
          ) {
            this.obrasRurales.push(
              this.loteRurales.lotePresupuestoEstado.presupuestosEstados[indice]
            );
          } else if (
            this.loteRurales.lotePresupuestoEstado.presupuestosEstados[indice]
              .nombreObra === this.CONSERVACION_INFRAESTRUCTURA
          ) {
            this.conservacionInfraestructuraRurales.push(
              this.loteRurales.lotePresupuestoEstado.presupuestosEstados[indice]
            );
          } else if (
            this.loteRurales.lotePresupuestoEstado.presupuestosEstados[indice]
              .nombreObra === this.ESTUDIOS_Y_PROYECTOS_RURALES
          ) {
            this.estudiosProyectosRurales.push(
              this.loteRurales.lotePresupuestoEstado.presupuestosEstados[indice]
            );
          }
        }
      }
    }
  }

  public async identificarTipoPrograma() {
    switch (this.tipoProgramaSeleccionado) {
      case "CMF":
        this.obtenerDatosPorProgramaObras(this.obrasFederales);
        break;
      case "DVF":
        this.obtenerDatosPorPrograma(this.derechoViaFederales);
        break;
      case "EPF":
        this.obtenerDatosPorPrograma(this.estudiosProyectosFederales);
        break;
      case "CRAR":
        this.obtenerDatosPorProgramaObras(this.obrasRurales);
        break;
      case "CRR":
        this.obtenerDatosPorPrograma(this.conservacionInfraestructuraRurales);
        break;
      case "EPR":
        this.obtenerDatosPorPrograma(this.estudiosProyectosRurales);
        break;
      case "ReporteCompleto":
        await this.obtenerDatosPorProgramaObras(this.obrasFederales);
        await this.obtenerDatosPorPrograma(this.derechoViaFederales);
        await this.obtenerDatosPorPrograma(this.estudiosProyectosFederales);
        await this.obtenerDatosPorProgramaObras(this.obrasRurales);
        await this.obtenerDatosPorPrograma(
          this.conservacionInfraestructuraRurales
        );
        await this.obtenerDatosPorPrograma(this.estudiosProyectosRurales);
        const monthNames = [
          "Enero",
          "Febrero",
          "Marzo",
          "Abril",
          "Mayo",
          "Junio",
          "Julio",
          "Agosto",
          "Septiembre",
          "Octubre",
          "Noviembre",
          "Diciembre",
        ];
        let fechaFederales: Date = new Date(
          this.lotesPresupuestos[1].fechaCreacion
        );
        this.fechaFederal =
          fechaFederales.getUTCDate() +
          " de " +
          monthNames[fechaFederales.getUTCMonth()] +
          " de " +
          fechaFederales.getUTCFullYear();
        let fechaRurales: Date = new Date(
          this.lotesPresupuestos[0].fechaCreacion
        );
        this.fechaRural =
          fechaRurales.getUTCDate() +
          " de " +
          monthNames[fechaRurales.getUTCMonth()] +
          " de " +
          fechaRurales.getUTCFullYear();
        this.reporteCompleto[0].fechaCreacion = this.fechaFederal;
        this.reporteCompleto[1].fechaCreacion = this.fechaFederal;
        this.reporteCompleto[2].fechaCreacion = this.fechaFederal;
        this.reporteCompleto[3].fechaCreacion = this.fechaRural;
        this.reporteCompleto[4].fechaCreacion = this.fechaRural;
        this.reporteCompleto[5].fechaCreacion = this.fechaRural;
        break;
      default:
        console.log("No se encontro tipo de programa (DEFAULT SWITCH)");
        break;
    }
  }

  public async obtenerDatosPorProgramaObras(
    datosProgramaSeleccionado: PresupuestoEstado[]
  ) {
    this.sumaObras = [];
    this.sumaTotalObras = null;

    for (
      let indexUR = 0;
      indexUR < this.catUnidadesResponsables.length;
      indexUR++
    ) {
      let valoresFiltrados: PresupuestoEstado[] = [];
      let obras: any = {};
      valoresFiltrados = datosProgramaSeleccionado.filter(
        (programa: PresupuestoEstado) =>
          programa.ur === this.catUnidadesResponsables[indexUR].cve.toString()
      );
      if (valoresFiltrados.length > 0) {
        obras.estado = this.catUnidadesResponsables[indexUR].cve.toString();
        obras.sumaPEF = valoresFiltrados.reduce(
          (prev, curr) => prev + curr.pef,
          0
        );
        obras.sumaModificado = valoresFiltrados.reduce(
          (prev, curr) => prev + curr.modificadoSia,
          0
        );
        obras.sumaContratadoTotal = valoresFiltrados.reduce(
          (prev, curr) => prev + curr.contratadoEnSistema,
          0
        );
        obras.sumaCalendarioAcumulado = valoresFiltrados.reduce(
          (prev, curr) => prev + curr.calendario,
          0
        );
        obras.sumaCalendarioEjercido = valoresFiltrados.reduce(
          (prev, curr) => prev + curr.calendarioVsTotalEjercido,
          0
        );
        obras.sumaTramitePago = valoresFiltrados.reduce(
          (prev, curr) => prev + curr.ejercidoEnTramite,
          0
        );
        obras.sumaEjercidoSIA = valoresFiltrados.reduce(
          (prev, curr) => prev + curr.ejercidoSia,
          0
        );
        obras.sumaEjercidoSIAFF = valoresFiltrados.reduce(
          (prev, curr) => prev + curr.ejercidoSiaff,
          0
        );
        obras.sumaTotalEjercido = valoresFiltrados.reduce(
          (prev, curr) => prev + curr.totalEjercido,
          0
        );
        obras.sumaCalendarioVsTotalEjercido = valoresFiltrados.reduce(
          (prev, curr) => prev + curr.calendarioVsTotalEjercido,
          0
        );
        obras.programa = [];
        obras.programa = valoresFiltrados;
        this.sumaObras.push(obras);
      }
    }

    let sumasCaminos: any = {};
    sumasCaminos.sumaPEF = this.sumaObras.reduce(
      (prev, curr) => prev + curr.sumaPEF,
      0
    );
    sumasCaminos.sumaModificado = this.sumaObras.reduce(
      (prev, curr) => prev + curr.sumaModificado,
      0
    );
    sumasCaminos.sumaContratadoTotal = this.sumaObras.reduce(
      (prev, curr) => prev + curr.sumaContratadoTotal,
      0
    );
    sumasCaminos.sumaCalendarioAcumulado = this.sumaObras.reduce(
      (prev, curr) => prev + curr.sumaCalendarioAcumulado,
      0
    );
    sumasCaminos.sumaCalendarioEjercido = this.sumaObras.reduce(
      (prev, curr) => prev + curr.sumaCalendarioEjercido,
      0
    );
    sumasCaminos.sumaTramitePago = this.sumaObras.reduce(
      (prev, curr) => prev + curr.sumaTramitePago,
      0
    );
    sumasCaminos.sumaEjercidoSIA = this.sumaObras.reduce(
      (prev, curr) => prev + curr.sumaEjercidoSIA,
      0
    );
    sumasCaminos.sumaEjercidoSIAFF = this.sumaObras.reduce(
      (prev, curr) => prev + curr.sumaEjercidoSIAFF,
      0
    );
    sumasCaminos.sumaTotalEjercido = this.sumaObras.reduce(
      (prev, curr) => prev + curr.sumaTotalEjercido,
      0
    );
    sumasCaminos.sumaCalendarioVsTotalEjercido = this.sumaObras.reduce(
      (prev, curr) => prev + curr.sumaCalendarioVsTotalEjercido,
      0
    );
    this.sumaTotalObras = sumasCaminos;

    let datosSeguimientoPEF: any = {};
    datosSeguimientoPEF.sumaObras = this.sumaObras;
    datosSeguimientoPEF.sumaTotalObras = this.sumaTotalObras;
    datosSeguimientoPEF.tipoProgramaSeleccionado =
      this.tipoProgramaSeleccionado;
    if (this.tipoProgramaSeleccionado !== "ReporteCompleto") {
      datosSeguimientoPEF.fechaCreacion = await this.identificarDireccion();
    }
    this.datosSeguimientoPEF = datosSeguimientoPEF;

    if (this.tipoProgramaSeleccionado === "ReporteCompleto") {
      this.reporteCompleto.push(this.datosSeguimientoPEF);
    }
  }

  public async obtenerDatosPorPrograma(
    datosProgramaSeleccionado: PresupuestoEstado[]
  ) {
    this.sumasProgramas = [];
    this.sumasTotalProgramas = null;

    for (
      let indexUR = 0;
      indexUR < this.catUnidadesResponsables.length;
      indexUR++
    ) {
      let valoresFiltrados: PresupuestoEstado[] = [];
      let sumaTotal: any = {};
      valoresFiltrados = datosProgramaSeleccionado.filter(
        (programa: PresupuestoEstado) =>
          programa.ur === this.catUnidadesResponsables[indexUR].cve.toString()
      );
      sumaTotal.estado = this.catUnidadesResponsables[indexUR].cve.toString();
      sumaTotal.sumaPEF = valoresFiltrados.reduce(
        (prev, curr) => prev + curr.pef,
        0
      );
      sumaTotal.sumaModificado = valoresFiltrados.reduce(
        (prev, curr) => prev + curr.modificadoSia,
        0
      );
      sumaTotal.sumaContratadoTotal = valoresFiltrados.reduce(
        (prev, curr) => prev + curr.contratadoEnSistema,
        0
      );
      sumaTotal.sumaCalendarioAcumulado = valoresFiltrados.reduce(
        (prev, curr) => prev + curr.calendario,
        0
      );
      sumaTotal.sumaCalendarioEjercido = valoresFiltrados.reduce(
        (prev, curr) => prev + curr.calendarioVsTotalEjercido,
        0
      );
      sumaTotal.sumaTramitePago = valoresFiltrados.reduce(
        (prev, curr) => prev + curr.ejercidoEnTramite,
        0
      );
      sumaTotal.sumaEjercidoSIA = valoresFiltrados.reduce(
        (prev, curr) => prev + curr.ejercidoSia,
        0
      );
      sumaTotal.sumaEjercidoSIAFF = valoresFiltrados.reduce(
        (prev, curr) => prev + curr.ejercidoSiaff,
        0
      );
      sumaTotal.sumaTotalEjercido = valoresFiltrados.reduce(
        (prev, curr) => prev + curr.totalEjercido,
        0
      );
      sumaTotal.sumaCalendarioVsTotalEjercido = valoresFiltrados.reduce(
        (prev, curr) => prev + curr.calendarioVsTotalEjercido,
        0
      );
      this.sumasProgramas.push(sumaTotal);
    }
    let sumasProgramas: any = {};
    sumasProgramas.sumaPEF = this.sumasProgramas.reduce(
      (prev, curr) => prev + curr.sumaPEF,
      0
    );
    sumasProgramas.sumaModificado = this.sumasProgramas.reduce(
      (prev, curr) => prev + curr.sumaModificado,
      0
    );
    sumasProgramas.sumaContratadoTotal = this.sumasProgramas.reduce(
      (prev, curr) => prev + curr.sumaContratadoTotal,
      0
    );
    sumasProgramas.sumaCalendarioAcumulado = this.sumasProgramas.reduce(
      (prev, curr) => prev + curr.sumaCalendarioAcumulado,
      0
    );
    sumasProgramas.sumaCalendarioEjercido = this.sumasProgramas.reduce(
      (prev, curr) => prev + curr.sumaCalendarioEjercido,
      0
    );
    sumasProgramas.sumaTramitePago = this.sumasProgramas.reduce(
      (prev, curr) => prev + curr.sumaTramitePago,
      0
    );
    sumasProgramas.sumaEjercidoSIA = this.sumasProgramas.reduce(
      (prev, curr) => prev + curr.sumaEjercidoSIA,
      0
    );
    sumasProgramas.sumaEjercidoSIAFF = this.sumasProgramas.reduce(
      (prev, curr) => prev + curr.sumaEjercidoSIAFF,
      0
    );
    sumasProgramas.sumaTotalEjercido = this.sumasProgramas.reduce(
      (prev, curr) => prev + curr.sumaTotalEjercido,
      0
    );
    sumasProgramas.sumaCalendarioVsTotalEjercido = this.sumasProgramas.reduce(
      (prev, curr) => prev + curr.sumaCalendarioVsTotalEjercido,
      0
    );
    this.sumasTotalProgramas = sumasProgramas;

    let datosSeguimientoPEF: any = {};
    datosSeguimientoPEF.sumasProgramas = this.sumasProgramas;
    datosSeguimientoPEF.sumasTotalProgramas = this.sumasTotalProgramas;
    datosSeguimientoPEF.tipoProgramaSeleccionado =
      this.tipoProgramaSeleccionado;
    datosSeguimientoPEF.fechaCreacion = await this.identificarDireccion();
    this.datosSeguimientoPEF = datosSeguimientoPEF;

    if (this.tipoProgramaSeleccionado === "ReporteCompleto") {
      this.reporteCompleto.push(this.datosSeguimientoPEF);
    }
  }

  public cerrarModal(): void {
    this.modalActivo.close();
  }

  public async descargarPDFReporteCompleto(): Promise<void> {
    this.loaderScreenService.activarLoaderScreen();
    let promesaImgB64: Promise<string> = new Promise<string>((resolve, err) => {
      let img = new Image();
      img.crossOrigin = "Anonymous";
      img.onload = () => {
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");
        canvas.height = img.naturalHeight;
        canvas.width = img.naturalWidth;
        ctx.drawImage(img, 0, 0);
        let uri = canvas.toDataURL("image/png");
        let b64: string = uri.replace(/^data:image.+;base64,/, "");
        resolve(b64);
      };
      let url: string = "../../../../../assets/img/logo3.png";
      img.src = url;
    });
    let base64Img: string = await promesaImgB64;
    let formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "MXN",
    });
    let bodyPrimerTabla: any[] = [];
    this.reporteCompleto[0].sumaObras.forEach((datos: any) => {
      bodyPrimerTabla.push([
        {
          content: this.obtenerNombreEstado(datos.estado).toUpperCase(),
          colSpan: 3,
          styles: {
            halign: "center",
            valign: "middle",
            fillColor: [243, 244, 244],
          },
        },
        {
          content: formatter.format(datos.sumaPEF).substring(3),
          styles: {
            halign: "center",
            valign: "middle",
            fillColor: [243, 244, 244],
          },
        },
        {
          content: formatter.format(datos.sumaModificado).substring(3),
          styles: {
            halign: "center",
            valign: "middle",
            fillColor: [243, 244, 244],
          },
        },
        {
          content: formatter.format(datos.sumaContratadoTotal).substring(3),
          styles: {
            halign: "center",
            valign: "middle",
            fillColor: [243, 244, 244],
          },
        },
        {
          content: formatter.format(datos.sumaCalendarioAcumulado).substring(3),
          styles: {
            halign: "center",
            valign: "middle",
            fillColor: [243, 244, 244],
          },
        },
        {
          content: formatter.format(datos.sumaCalendarioEjercido).substring(3),
          styles: {
            halign: "center",
            valign: "middle",
            fillColor: [243, 244, 244],
          },
        },
        {
          content: formatter.format(datos.sumaTramitePago).substring(3),
          styles: {
            halign: "center",
            valign: "middle",
            fillColor: [243, 244, 244],
          },
        },
        {
          content: formatter.format(datos.sumaEjercidoSIA).substring(3),
          styles: {
            halign: "center",
            valign: "middle",
            fillColor: [243, 244, 244],
          },
        },
        {
          content: formatter.format(datos.sumaEjercidoSIAFF).substring(3),
          styles: {
            halign: "center",
            valign: "middle",
            fillColor: [243, 244, 244],
          },
        },
        {
          content: formatter.format(datos.sumaTotalEjercido).substring(3),
          styles: {
            halign: "center",
            valign: "middle",
            fillColor: [243, 244, 244],
          },
        },
        {
          content: formatter.format(datos.sumaCalendarioAcumulado).substring(3),
          styles: {
            halign: "center",
            valign: "middle",
            fillColor: [243, 244, 244],
          },
        },
        {
          content: formatter.format(datos.sumaCalendarioEjercido).substring(3),
          styles: {
            halign: "center",
            valign: "middle",
            fillColor: [243, 244, 244],
          },
        },
      ]);
      datos.programa.forEach((presupuesto: any, indice: number) => {
        bodyPrimerTabla.push([
          { content: indice + 1, styles: { minCellWidth: 8 } },
          { content: presupuesto.registro, styles: { minCellWidth: 16 } },
          { content: presupuesto.nombreObra, styles: { halign: "left" } },
          { content: formatter.format(presupuesto.pef).substring(3) },
          { content: formatter.format(presupuesto.modificadoSia).substring(3) },
          {
            content: formatter
              .format(presupuesto.contratadoEnSistema)
              .substring(3),
          },
          { content: formatter.format(presupuesto.calendario).substring(3) },
          {
            content: formatter
              .format(presupuesto.calendarioVsTotalEjercido)
              .substring(3),
          },
          {
            content: formatter
              .format(presupuesto.ejercidoEnTramite)
              .substring(3),
          },
          { content: formatter.format(presupuesto.ejercidoSia).substring(3) },
          { content: formatter.format(presupuesto.ejercidoSiaff).substring(3) },
          { content: formatter.format(presupuesto.totalEjercido).substring(3) },
          { content: formatter.format(presupuesto.calendario).substring(3) },
          {
            content: formatter
              .format(presupuesto.calendarioVsTotalEjercido)
              .substring(3),
          },
        ]);
      });
    });
    let footPrimerTabla: any = [
      [
        { content: "TOTAL", colSpan: 3 },
        {
          content: formatter
            .format(this.reporteCompleto[0].sumaTotalObras.sumaPEF)
            .substring(3),
        },
        {
          content: formatter
            .format(this.reporteCompleto[0].sumaTotalObras.sumaModificado)
            .substring(3),
        },
        {
          content: formatter
            .format(this.reporteCompleto[0].sumaTotalObras.sumaContratadoTotal)
            .substring(3),
        },
        {
          content: formatter
            .format(
              this.reporteCompleto[0].sumaTotalObras.sumaCalendarioAcumulado
            )
            .substring(3),
        },
        {
          content: formatter
            .format(
              this.reporteCompleto[0].sumaTotalObras.sumaCalendarioEjercido
            )
            .substring(3),
        },
        {
          content: formatter
            .format(this.reporteCompleto[0].sumaTotalObras.sumaTramitePago)
            .substring(3),
        },
        {
          content: formatter
            .format(this.reporteCompleto[0].sumaTotalObras.sumaEjercidoSIA)
            .substring(3),
        },
        {
          content: formatter
            .format(this.reporteCompleto[0].sumaTotalObras.sumaEjercidoSIAFF)
            .substring(3),
        },
        {
          content: formatter
            .format(this.reporteCompleto[0].sumaTotalObras.sumaTotalEjercido)
            .substring(3),
        },
        {
          content: formatter
            .format(
              this.reporteCompleto[0].sumaTotalObras
                .sumaCalendarioVsTotalEjercido
            )
            .substring(3),
        },
        {
          content: formatter
            .format(
              this.reporteCompleto[0].sumaTotalObras
                .sumaCalendarioVsTotalEjercido
            )
            .substring(3),
        },
      ],
    ];
    let bodySegundaTabla: any = this.reporteCompleto[1].sumasProgramas.map(
      (datosPrograma: any) => {
        return [
          this.obtenerNombreEstado(datosPrograma.estado).toUpperCase(),
          formatter.format(datosPrograma.sumaPEF).substring(3),
          formatter.format(datosPrograma.sumaModificado).substring(3),
          formatter.format(datosPrograma.sumaContratadoTotal).substring(3),
          formatter.format(datosPrograma.sumaCalendarioAcumulado).substring(3),
          formatter.format(datosPrograma.sumaCalendarioEjercido).substring(3),
          formatter.format(datosPrograma.sumaTramitePago).substring(3),
          formatter.format(datosPrograma.sumaEjercidoSIA).substring(3),
          formatter.format(datosPrograma.sumaEjercidoSIAFF).substring(3),
          formatter.format(datosPrograma.sumaTotalEjercido).substring(3),
          formatter.format(datosPrograma.sumaCalendarioAcumulado).substring(3),
          formatter.format(datosPrograma.sumaCalendarioEjercido).substring(3),
        ];
      }
    );
    let footSegundaTabla: any = [
      [
        "TOTAL",
        formatter
          .format(this.reporteCompleto[1].sumasTotalProgramas.sumaPEF)
          .substring(3),
        formatter
          .format(this.reporteCompleto[1].sumasTotalProgramas.sumaModificado)
          .substring(3),
        formatter
          .format(
            this.reporteCompleto[1].sumasTotalProgramas.sumaContratadoTotal
          )
          .substring(3),
        formatter
          .format(
            this.reporteCompleto[1].sumasTotalProgramas.sumaCalendarioAcumulado
          )
          .substring(3),
        formatter
          .format(
            this.reporteCompleto[1].sumasTotalProgramas.sumaCalendarioEjercido
          )
          .substring(3),
        formatter
          .format(this.reporteCompleto[1].sumasTotalProgramas.sumaTramitePago)
          .substring(3),
        formatter
          .format(this.reporteCompleto[1].sumasTotalProgramas.sumaEjercidoSIA)
          .substring(3),
        formatter
          .format(this.reporteCompleto[1].sumasTotalProgramas.sumaEjercidoSIAFF)
          .substring(3),
        formatter
          .format(this.reporteCompleto[1].sumasTotalProgramas.sumaTotalEjercido)
          .substring(3),
        formatter
          .format(
            this.reporteCompleto[1].sumasTotalProgramas
              .sumaCalendarioVsTotalEjercido
          )
          .substring(3),
        formatter
          .format(
            this.reporteCompleto[1].sumasTotalProgramas
              .sumaCalendarioVsTotalEjercido
          )
          .substring(3),
      ],
    ];
    let bodyTercerTabla: any = this.reporteCompleto[2].sumasProgramas.map(
      (datosPrograma: any) => {
        return [
          this.obtenerNombreEstado(datosPrograma.estado).toUpperCase(),
          formatter.format(datosPrograma.sumaPEF).substring(3),
          formatter.format(datosPrograma.sumaModificado).substring(3),
          formatter.format(datosPrograma.sumaContratadoTotal).substring(3),
          formatter.format(datosPrograma.sumaCalendarioAcumulado).substring(3),
          formatter.format(datosPrograma.sumaCalendarioEjercido).substring(3),
          formatter.format(datosPrograma.sumaTramitePago).substring(3),
          formatter.format(datosPrograma.sumaEjercidoSIA).substring(3),
          formatter.format(datosPrograma.sumaEjercidoSIAFF).substring(3),
          formatter.format(datosPrograma.sumaTotalEjercido).substring(3),
          formatter.format(datosPrograma.sumaCalendarioAcumulado).substring(3),
          formatter.format(datosPrograma.sumaCalendarioEjercido).substring(3),
        ];
      }
    );
    let footTercerTabla: any = [
      [
        "TOTAL",
        formatter
          .format(this.reporteCompleto[2].sumasTotalProgramas.sumaPEF)
          .substring(3),
        formatter
          .format(this.reporteCompleto[2].sumasTotalProgramas.sumaModificado)
          .substring(3),
        formatter
          .format(
            this.reporteCompleto[2].sumasTotalProgramas.sumaContratadoTotal
          )
          .substring(3),
        formatter
          .format(
            this.reporteCompleto[2].sumasTotalProgramas.sumaCalendarioAcumulado
          )
          .substring(3),
        formatter
          .format(
            this.reporteCompleto[2].sumasTotalProgramas.sumaCalendarioEjercido
          )
          .substring(3),
        formatter
          .format(this.reporteCompleto[2].sumasTotalProgramas.sumaTramitePago)
          .substring(3),
        formatter
          .format(this.reporteCompleto[2].sumasTotalProgramas.sumaEjercidoSIA)
          .substring(3),
        formatter
          .format(this.reporteCompleto[2].sumasTotalProgramas.sumaEjercidoSIAFF)
          .substring(3),
        formatter
          .format(this.reporteCompleto[2].sumasTotalProgramas.sumaTotalEjercido)
          .substring(3),
        formatter
          .format(
            this.reporteCompleto[2].sumasTotalProgramas
              .sumaCalendarioVsTotalEjercido
          )
          .substring(3),
        formatter
          .format(
            this.reporteCompleto[2].sumasTotalProgramas
              .sumaCalendarioVsTotalEjercido
          )
          .substring(3),
      ],
    ];
    let bodyCuartaTabla: any[] = [];
    this.reporteCompleto[3].sumaObras.forEach((datos: any) => {
      bodyCuartaTabla.push([
        {
          content: this.obtenerNombreEstado(datos.estado).toUpperCase(),
          colSpan: 3,
          styles: {
            halign: "center",
            valign: "middle",
            fillColor: [243, 244, 244],
          },
        },
        {
          content: formatter.format(datos.sumaPEF).substring(3),
          styles: {
            halign: "center",
            valign: "middle",
            fillColor: [243, 244, 244],
          },
        },
        {
          content: formatter.format(datos.sumaModificado).substring(3),
          styles: {
            halign: "center",
            valign: "middle",
            fillColor: [243, 244, 244],
          },
        },
        {
          content: formatter.format(datos.sumaContratadoTotal).substring(3),
          styles: {
            halign: "center",
            valign: "middle",
            fillColor: [243, 244, 244],
          },
        },
        {
          content: formatter.format(datos.sumaCalendarioAcumulado).substring(3),
          styles: {
            halign: "center",
            valign: "middle",
            fillColor: [243, 244, 244],
          },
        },
        {
          content: formatter.format(datos.sumaCalendarioEjercido).substring(3),
          styles: {
            halign: "center",
            valign: "middle",
            fillColor: [243, 244, 244],
          },
        },
        {
          content: formatter.format(datos.sumaTramitePago).substring(3),
          styles: {
            halign: "center",
            valign: "middle",
            fillColor: [243, 244, 244],
          },
        },
        {
          content: formatter.format(datos.sumaEjercidoSIA).substring(3),
          styles: {
            halign: "center",
            valign: "middle",
            fillColor: [243, 244, 244],
          },
        },
        {
          content: formatter.format(datos.sumaEjercidoSIAFF).substring(3),
          styles: {
            halign: "center",
            valign: "middle",
            fillColor: [243, 244, 244],
          },
        },
        {
          content: formatter.format(datos.sumaTotalEjercido).substring(3),
          styles: {
            halign: "center",
            valign: "middle",
            fillColor: [243, 244, 244],
          },
        },
        {
          content: formatter.format(datos.sumaCalendarioAcumulado).substring(3),
          styles: {
            halign: "center",
            valign: "middle",
            fillColor: [243, 244, 244],
          },
        },
        {
          content: formatter.format(datos.sumaCalendarioEjercido).substring(3),
          styles: {
            halign: "center",
            valign: "middle",
            fillColor: [243, 244, 244],
          },
        },
      ]);
      datos.programa.forEach((presupuesto: any, indice: number) => {
        bodyCuartaTabla.push([
          { content: indice + 1, styles: { minCellWidth: 8 } },
          { content: presupuesto.registro, styles: { minCellWidth: 16 } },
          { content: presupuesto.nombreObra, styles: { halign: "left" } },
          { content: formatter.format(presupuesto.pef).substring(3) },
          { content: formatter.format(presupuesto.modificadoSia).substring(3) },
          {
            content: formatter
              .format(presupuesto.contratadoEnSistema)
              .substring(3),
          },
          { content: formatter.format(presupuesto.calendario).substring(3) },
          {
            content: formatter
              .format(presupuesto.calendarioVsTotalEjercido)
              .substring(3),
          },
          {
            content: formatter
              .format(presupuesto.ejercidoEnTramite)
              .substring(3),
          },
          { content: formatter.format(presupuesto.ejercidoSia).substring(3) },
          { content: formatter.format(presupuesto.ejercidoSiaff).substring(3) },
          { content: formatter.format(presupuesto.totalEjercido).substring(3) },
          { content: formatter.format(presupuesto.calendario).substring(3) },
          {
            content: formatter
              .format(presupuesto.calendarioVsTotalEjercido)
              .substring(3),
          },
        ]);
      });
    });
    let footCuartaTabla: any = [
      [
        { content: "TOTAL", colSpan: 3 },
        {
          content: formatter
            .format(this.reporteCompleto[3].sumaTotalObras.sumaPEF)
            .substring(3),
        },
        {
          content: formatter
            .format(this.reporteCompleto[3].sumaTotalObras.sumaModificado)
            .substring(3),
        },
        {
          content: formatter
            .format(this.reporteCompleto[3].sumaTotalObras.sumaContratadoTotal)
            .substring(3),
        },
        {
          content: formatter
            .format(
              this.reporteCompleto[3].sumaTotalObras.sumaCalendarioAcumulado
            )
            .substring(3),
        },
        {
          content: formatter
            .format(
              this.reporteCompleto[3].sumaTotalObras.sumaCalendarioEjercido
            )
            .substring(3),
        },
        {
          content: formatter
            .format(this.reporteCompleto[3].sumaTotalObras.sumaTramitePago)
            .substring(3),
        },
        {
          content: formatter
            .format(this.reporteCompleto[3].sumaTotalObras.sumaEjercidoSIA)
            .substring(3),
        },
        {
          content: formatter
            .format(this.reporteCompleto[3].sumaTotalObras.sumaEjercidoSIAFF)
            .substring(3),
        },
        {
          content: formatter
            .format(this.reporteCompleto[3].sumaTotalObras.sumaTotalEjercido)
            .substring(3),
        },
        {
          content: formatter
            .format(
              this.reporteCompleto[3].sumaTotalObras
                .sumaCalendarioVsTotalEjercido
            )
            .substring(3),
        },
        {
          content: formatter
            .format(
              this.reporteCompleto[3].sumaTotalObras
                .sumaCalendarioVsTotalEjercido
            )
            .substring(3),
        },
      ],
    ];
    let bodyQuintaTabla: any = this.reporteCompleto[4].sumasProgramas.map(
      (datosPrograma: any) => {
        return [
          this.obtenerNombreEstado(datosPrograma.estado).toUpperCase(),
          formatter.format(datosPrograma.sumaPEF).substring(3),
          formatter.format(datosPrograma.sumaModificado).substring(3),
          formatter.format(datosPrograma.sumaContratadoTotal).substring(3),
          formatter.format(datosPrograma.sumaCalendarioAcumulado).substring(3),
          formatter.format(datosPrograma.sumaCalendarioEjercido).substring(3),
          formatter.format(datosPrograma.sumaTramitePago).substring(3),
          formatter.format(datosPrograma.sumaEjercidoSIA).substring(3),
          formatter.format(datosPrograma.sumaEjercidoSIAFF).substring(3),
          formatter.format(datosPrograma.sumaTotalEjercido).substring(3),
          formatter
            .format(datosPrograma.sumaCalendarioVsTotalEjercido)
            .substring(3),
          formatter
            .format(datosPrograma.sumaCalendarioVsTotalEjercido)
            .substring(3),
        ];
      }
    );
    let footQuintaTabla: any = [
      [
        "TOTAL",
        formatter
          .format(this.reporteCompleto[4].sumasTotalProgramas.sumaPEF)
          .substring(3),
        formatter
          .format(this.reporteCompleto[4].sumasTotalProgramas.sumaModificado)
          .substring(3),
        formatter
          .format(
            this.reporteCompleto[4].sumasTotalProgramas.sumaContratadoTotal
          )
          .substring(3),
        formatter
          .format(
            this.reporteCompleto[4].sumasTotalProgramas.sumaCalendarioAcumulado
          )
          .substring(3),
        formatter
          .format(
            this.reporteCompleto[4].sumasTotalProgramas.sumaCalendarioEjercido
          )
          .substring(3),
        formatter
          .format(this.reporteCompleto[4].sumasTotalProgramas.sumaTramitePago)
          .substring(3),
        formatter
          .format(this.reporteCompleto[4].sumasTotalProgramas.sumaEjercidoSIA)
          .substring(3),
        formatter
          .format(this.reporteCompleto[4].sumasTotalProgramas.sumaEjercidoSIAFF)
          .substring(3),
        formatter
          .format(this.reporteCompleto[4].sumasTotalProgramas.sumaTotalEjercido)
          .substring(3),
        formatter
          .format(
            this.reporteCompleto[4].sumasTotalProgramas
              .sumaCalendarioVsTotalEjercido
          )
          .substring(3),
        formatter
          .format(
            this.reporteCompleto[4].sumasTotalProgramas
              .sumaCalendarioVsTotalEjercido
          )
          .substring(3),
      ],
    ];
    let bodySextaTabla: any = this.reporteCompleto[5].sumasProgramas.map(
      (datosPrograma: any) => {
        return [
          this.obtenerNombreEstado(datosPrograma.estado).toUpperCase(),
          formatter.format(datosPrograma.sumaPEF).substring(3),
          formatter.format(datosPrograma.sumaModificado).substring(3),
          formatter.format(datosPrograma.sumaContratadoTotal).substring(3),
          formatter.format(datosPrograma.sumaCalendarioAcumulado).substring(3),
          formatter.format(datosPrograma.sumaCalendarioEjercido).substring(3),
          formatter.format(datosPrograma.sumaTramitePago).substring(3),
          formatter.format(datosPrograma.sumaEjercidoSIA).substring(3),
          formatter.format(datosPrograma.sumaEjercidoSIAFF).substring(3),
          formatter.format(datosPrograma.sumaTotalEjercido).substring(3),
          formatter.format(datosPrograma.sumaCalendarioAcumulado).substring(3),
          formatter.format(datosPrograma.sumaCalendarioEjercido).substring(3),
        ];
      }
    );
    let footSextaTabla: any = [
      [
        "TOTAL",
        formatter
          .format(this.reporteCompleto[5].sumasTotalProgramas.sumaPEF)
          .substring(3),
        formatter
          .format(this.reporteCompleto[5].sumasTotalProgramas.sumaModificado)
          .substring(3),
        formatter
          .format(
            this.reporteCompleto[5].sumasTotalProgramas.sumaContratadoTotal
          )
          .substring(3),
        formatter
          .format(
            this.reporteCompleto[5].sumasTotalProgramas.sumaCalendarioAcumulado
          )
          .substring(3),
        formatter
          .format(
            this.reporteCompleto[5].sumasTotalProgramas.sumaCalendarioEjercido
          )
          .substring(3),
        formatter
          .format(this.reporteCompleto[5].sumasTotalProgramas.sumaTramitePago)
          .substring(3),
        formatter
          .format(this.reporteCompleto[5].sumasTotalProgramas.sumaEjercidoSIA)
          .substring(3),
        formatter
          .format(this.reporteCompleto[5].sumasTotalProgramas.sumaEjercidoSIAFF)
          .substring(3),
        formatter
          .format(this.reporteCompleto[5].sumasTotalProgramas.sumaTotalEjercido)
          .substring(3),
        formatter
          .format(
            this.reporteCompleto[5].sumasTotalProgramas
              .sumaCalendarioVsTotalEjercido
          )
          .substring(3),
        formatter
          .format(
            this.reporteCompleto[5].sumasTotalProgramas
              .sumaCalendarioVsTotalEjercido
          )
          .substring(3),
      ],
    ];
    this.pdfUtils.descargarSeguimientoPEF(
      bodyPrimerTabla,
      footPrimerTabla,
      bodySegundaTabla,
      footSegundaTabla,
      bodyTercerTabla,
      footTercerTabla,
      bodyCuartaTabla,
      footCuartaTabla,
      bodyQuintaTabla,
      footQuintaTabla,
      bodySextaTabla,
      footSextaTabla,
      base64Img,
      this.fechaFederal,
      this.fechaRural
    );
  }

  public async descargarPDFObras(tituloHeader: string): Promise<void> {
    this.loaderScreenService.activarLoaderScreen();
    let promesaImgB64: Promise<string> = new Promise<string>((resolve, err) => {
      let img = new Image();
      img.crossOrigin = "Anonymous";
      img.onload = () => {
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");
        canvas.height = img.naturalHeight;
        canvas.width = img.naturalWidth;
        ctx.drawImage(img, 0, 0);
        let uri = canvas.toDataURL("image/png");
        let b64: string = uri.replace(/^data:image.+;base64,/, "");
        resolve(b64);
      };
      let url: string = "../../../../../assets/img/logo3.png";
      img.src = url;
    });
    let base64Img: string = await promesaImgB64;
    let formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "MXN",
    });
    let bodySegundaTabla: any[] = [];
    this.datosSeguimientoPEF.sumaObras.forEach((datos: any) => {
      bodySegundaTabla.push([
        {
          content: this.obtenerNombreEstado(datos.estado).toUpperCase(),
          colSpan: 3,
          styles: {
            halign: "center",
            valign: "middle",
            fillColor: [243, 244, 244],
          },
        },
        {
          content: formatter.format(datos.sumaPEF).substring(3),
          styles: {
            halign: "center",
            valign: "middle",
            fillColor: [243, 244, 244],
          },
        },
        {
          content: formatter.format(datos.sumaModificado).substring(3),
          styles: {
            halign: "center",
            valign: "middle",
            fillColor: [243, 244, 244],
          },
        },
        {
          content: formatter.format(datos.sumaContratadoTotal).substring(3),
          styles: {
            halign: "center",
            valign: "middle",
            fillColor: [243, 244, 244],
          },
        },
        {
          content: formatter.format(datos.sumaCalendarioAcumulado).substring(3),
          styles: {
            halign: "center",
            valign: "middle",
            fillColor: [243, 244, 244],
          },
        },
        {
          content: formatter.format(datos.sumaCalendarioEjercido).substring(3),
          styles: {
            halign: "center",
            valign: "middle",
            fillColor: [243, 244, 244],
          },
        },
        {
          content: formatter.format(datos.sumaTramitePago).substring(3),
          styles: {
            halign: "center",
            valign: "middle",
            fillColor: [243, 244, 244],
          },
        },
        {
          content: formatter.format(datos.sumaEjercidoSIA).substring(3),
          styles: {
            halign: "center",
            valign: "middle",
            fillColor: [243, 244, 244],
          },
        },
        {
          content: formatter.format(datos.sumaEjercidoSIAFF).substring(3),
          styles: {
            halign: "center",
            valign: "middle",
            fillColor: [243, 244, 244],
          },
        },
        {
          content: formatter.format(datos.sumaTotalEjercido).substring(3),
          styles: {
            halign: "center",
            valign: "middle",
            fillColor: [243, 244, 244],
          },
        },
        {
          content: formatter
            .format(datos.sumaCalendarioVsTotalEjercido)
            .substring(3),
          styles: {
            halign: "center",
            valign: "middle",
            fillColor: [243, 244, 244],
          },
        },
        {
          content: formatter
            .format(datos.sumaCalendarioVsTotalEjercido)
            .substring(3),
          styles: {
            halign: "center",
            valign: "middle",
            fillColor: [243, 244, 244],
          },
        },
      ]);
      datos.programa.forEach((presupuesto: any, indice: number) => {
        bodySegundaTabla.push([
          { content: indice + 1, styles: { minCellWidth: 8 } },
          { content: presupuesto.registro, styles: { minCellWidth: 16 } },
          { content: presupuesto.nombreObra, styles: { halign: "left" } },
          { content: formatter.format(presupuesto.pef).substring(3) },
          { content: formatter.format(presupuesto.modificadoSia).substring(3) },
          {
            content: formatter
              .format(presupuesto.contratadoEnSistema)
              .substring(3),
          },
          { content: formatter.format(presupuesto.calendario).substring(3) },
          {
            content: formatter
              .format(presupuesto.calendarioVsTotalEjercido)
              .substring(3),
          },
          {
            content: formatter
              .format(presupuesto.ejercidoEnTramite)
              .substring(3),
          },
          { content: formatter.format(presupuesto.ejercidoSia).substring(3) },
          { content: formatter.format(presupuesto.ejercidoSiaff).substring(3) },
          { content: formatter.format(presupuesto.totalEjercido).substring(3) },
          {
            content: formatter
              .format(presupuesto.calendarioVsTotalEjercido)
              .substring(3),
          },
          {
            content: formatter
              .format(presupuesto.calendarioVsTotalEjercido)
              .substring(3),
          },
        ]);
      });
    });

    let footSegundaTabla: any = [
      [
        { content: "TOTAL", colSpan: 3 },
        {
          content: formatter
            .format(this.datosSeguimientoPEF.sumaTotalObras.sumaPEF)
            .substring(3),
        },
        {
          content: formatter
            .format(this.datosSeguimientoPEF.sumaTotalObras.sumaModificado)
            .substring(3),
        },
        {
          content: formatter
            .format(this.datosSeguimientoPEF.sumaTotalObras.sumaContratadoTotal)
            .substring(3),
        },
        {
          content: formatter
            .format(
              this.datosSeguimientoPEF.sumaTotalObras.sumaCalendarioAcumulado
            )
            .substring(3),
        },
        {
          content: formatter
            .format(
              this.datosSeguimientoPEF.sumaTotalObras.sumaCalendarioEjercido
            )
            .substring(3),
        },
        {
          content: formatter
            .format(this.datosSeguimientoPEF.sumaTotalObras.sumaTramitePago)
            .substring(3),
        },
        {
          content: formatter
            .format(this.datosSeguimientoPEF.sumaTotalObras.sumaEjercidoSIA)
            .substring(3),
        },
        {
          content: formatter
            .format(this.datosSeguimientoPEF.sumaTotalObras.sumaEjercidoSIAFF)
            .substring(3),
        },
        {
          content: formatter
            .format(this.datosSeguimientoPEF.sumaTotalObras.sumaTotalEjercido)
            .substring(3),
        },
        {
          content: formatter
            .format(
              this.datosSeguimientoPEF.sumaTotalObras
                .sumaCalendarioVsTotalEjercido
            )
            .substring(3),
        },
        {
          content: formatter
            .format(
              this.datosSeguimientoPEF.sumaTotalObras
                .sumaCalendarioVsTotalEjercido
            )
            .substring(3),
        },
      ],
    ];
    this.pdfUtils.descargarSeguimientoPEFObras(
      bodySegundaTabla,
      footSegundaTabla,
      base64Img,
      tituloHeader,
      this.fechaActual
    );
  }

  public async descargarPDFProgramas(tituloHeader: string): Promise<void> {
    this.loaderScreenService.activarLoaderScreen();
    let promesaImgB64: Promise<string> = new Promise<string>((resolve, err) => {
      let img = new Image();
      img.crossOrigin = "Anonymous";
      img.onload = () => {
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");
        canvas.height = img.naturalHeight;
        canvas.width = img.naturalWidth;
        ctx.drawImage(img, 0, 0);
        let uri = canvas.toDataURL("image/png");
        let b64: string = uri.replace(/^data:image.+;base64,/, "");
        resolve(b64);
      };
      let url: string = "../../../../../assets/img/logo3.png";
      img.src = url;
    });
    let base64Img: string = await promesaImgB64;
    let formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "MXN",
    });
    let bodyPrimerTabla: any = this.datosSeguimientoPEF.sumasProgramas.map(
      (datosPrograma: any) => {
        return [
          this.obtenerNombreEstado(datosPrograma.estado).toUpperCase(),
          formatter.format(datosPrograma.sumaPEF).substring(3),
          formatter.format(datosPrograma.sumaModificado).substring(3),
          formatter.format(datosPrograma.sumaContratadoTotal).substring(3),
          formatter.format(datosPrograma.sumaCalendarioAcumulado).substring(3),
          formatter.format(datosPrograma.sumaCalendarioEjercido).substring(3),
          formatter.format(datosPrograma.sumaTramitePago).substring(3),
          formatter.format(datosPrograma.sumaEjercidoSIA).substring(3),
          formatter.format(datosPrograma.sumaEjercidoSIAFF).substring(3),
          formatter.format(datosPrograma.sumaTotalEjercido).substring(3),
          formatter
            .format(datosPrograma.sumaCalendarioVsTotalEjercido)
            .substring(3),
          formatter
            .format(datosPrograma.sumaCalendarioVsTotalEjercido)
            .substring(3),
        ];
      }
    );
    let footPrimerTabla: any = [
      [
        "TOTAL",
        formatter
          .format(this.datosSeguimientoPEF.sumasTotalProgramas.sumaPEF)
          .substring(3),
        formatter
          .format(this.datosSeguimientoPEF.sumasTotalProgramas.sumaModificado)
          .substring(3),
        formatter
          .format(
            this.datosSeguimientoPEF.sumasTotalProgramas.sumaContratadoTotal
          )
          .substring(3),
        formatter
          .format(
            this.datosSeguimientoPEF.sumasTotalProgramas.sumaCalendarioAcumulado
          )
          .substring(3),
        formatter
          .format(
            this.datosSeguimientoPEF.sumasTotalProgramas.sumaCalendarioEjercido
          )
          .substring(3),
        formatter
          .format(this.datosSeguimientoPEF.sumasTotalProgramas.sumaTramitePago)
          .substring(3),
        formatter
          .format(this.datosSeguimientoPEF.sumasTotalProgramas.sumaEjercidoSIA)
          .substring(3),
        formatter
          .format(
            this.datosSeguimientoPEF.sumasTotalProgramas.sumaEjercidoSIAFF
          )
          .substring(3),
        formatter
          .format(
            this.datosSeguimientoPEF.sumasTotalProgramas.sumaTotalEjercido
          )
          .substring(3),
        formatter
          .format(
            this.datosSeguimientoPEF.sumasTotalProgramas
              .sumaCalendarioVsTotalEjercido
          )
          .substring(3),
        formatter
          .format(
            this.datosSeguimientoPEF.sumasTotalProgramas
              .sumaCalendarioVsTotalEjercido
          )
          .substring(3),
      ],
    ];
    this.pdfUtils.descargarSeguimientoProgramas(
      bodyPrimerTabla,
      footPrimerTabla,
      base64Img,
      tituloHeader,
      this.fechaActual
    );
  }

  public async descargarPDF(): Promise<void> {
    switch (this.tipoProgramaSeleccionado) {
      case "CMF":
        this.descargarPDFObras(
          this.TITULO_CONSTRUCCION_MODERNIZACION_FEDERALES
        );
        break;
      case "DVF":
        this.descargarPDFProgramas(this.TITULO_PROGRAMA_DERECHO_VIA_FEDERALES);
        break;
      case "EPF":
        this.descargarPDFProgramas(
          this.TITULO_PROGRAMA_ESTUDIOS_PROYECTOS_FEDERALES
        );
        break;
      case "CRAR":
        this.descargarPDFObras(this.TITULO_CAMINOS_RURALES_Y_ALIMENTADORES);
        break;
      case "CRR":
        this.descargarPDFProgramas(
          this.TITULO_PROGRAMA_CONSERVACION_CARRETERAS
        );
        break;
      case "EPR":
        this.descargarPDFProgramas(
          this.TITULO_PROGRAMA_ESTUDIOS_PROYECTOS_RURALES
        );
        break;
      case "ReporteCompleto":
        this.descargarPDFReporteCompleto();
        break;
      default:
        console.warn("No se encontro tipo de programa (DEFAULT SWITCH)");
        break;
    }
  }

  public async identificarDireccion() {
    const monthNames = [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ];

    if (
      this.tipoProgramaSeleccionado === "CMF" ||
      this.tipoProgramaSeleccionado === "DVF" ||
      this.tipoProgramaSeleccionado === "EPF"
    ) {
      let fechaConvert: Date = new Date(
        this.lotesPresupuestos[1].fechaCreacion
      );
      this.fechaActual =
        fechaConvert.getUTCDate() +
        " de " +
        monthNames[fechaConvert.getUTCMonth()] +
        " de " +
        fechaConvert.getUTCFullYear();
      return this.fechaActual;
    } else if (
      this.tipoProgramaSeleccionado === "CRAR" ||
      this.tipoProgramaSeleccionado === "CRR" ||
      this.tipoProgramaSeleccionado === "EPR"
    ) {
      let fechaConvert: Date = new Date(
        this.lotesPresupuestos[0].fechaCreacion
      );
      this.fechaActual =
        fechaConvert.getUTCDate() +
        " de " +
        monthNames[fechaConvert.getUTCMonth()] +
        " de " +
        fechaConvert.getUTCFullYear();
      return this.fechaActual;
    }
  }

  public obtenerNombreEstado(keyUR: string): string {
    return this.catUnidadesResponsables.find((ur: any) => ur.cve == keyUR)
      .nombreEstado;
  }
}
